export const caseStudies = [
  // {
  //   id: 'case-study-1',
  //   hasInteractiveDemo: true,
  //   title: "Case Study Title",
  //   timeline: "Month Year - Month Year",
  //   role: "Your Role",
  //   summary: "Brief summary of what you did and the impact.",
  //   problem: "The problem you were solving.",
  //   metrics: [
  //     "Metric 1",
  //     "Metric 2",
  //     "Metric 3",
  //     "Metric 4"
  //   ],
  //   skills: ["Skill 1", "Skill 2", "Skill 3"],
  //   fullContent: {
  //     challenge: `Detailed description of the challenge.`,
  //     research: `Research methods and findings.`,
  //     solution: `Solution overview and key features.`,
  //     results: `Quantitative and qualitative results.`,
  //     learnings: `What worked well and what you'd do differently.`
  //   }
  // },   
{
  id: 'meddra-autocoder',
  title: "Clinical Terminology Auto-Coding Tool",
  timeline: "2024",
  role: "Product Lead",
  
  // CARD VERSION - scannable, no fluff
  summary: "Led product strategy for an intelligent system that automates mapping of adverse event terms to standardized medical terminology, reducing manual coding effort and improving data consistency across clinical trials.",
  
  problem: "Clinical coders spent hours manually matching free-text adverse events to dictionary codes—a repetitive task prone to inconsistency that created bottlenecks in trial timelines.",
  
  // Qualitative outcomes, not fabricated numbers
  metrics: [
    "Reduced manual coding burden",
    "Improved coding consistency",
    "Streamlined audit compliance",
    "Accelerated database lock"
  ],
  
  skills: [
    "Product Strategy",
    "Healthcare/Life Sciences",
    "User Research",
    "Regulatory Compliance"
  ],
  
  hasInteractiveDemo: true,
  
  // FULL VERSION - detailed but honest
  fullContent: {
    challenge: `Clinical trials generate thousands of adverse event reports requiring standardized MedDRA coding for regulatory submission. The existing workflow was entirely manual:

• Coders received verbatim terms via spreadsheet exports
• Each term required searching a separate dictionary browser
• Selections were recorded in a tracking system, then re-entered into the EDC
• No systematic audit trail for coding decisions

This fragmented process created bottlenecks approaching database lock and inconsistent coding decisions that generated downstream queries.`,

    research: `Discovery focused on understanding the problem from multiple angles:

USER RESEARCH
Conducted contextual inquiry sessions with clinical data coders, observing their workflows and identifying pain points. Key insight: most terms had straightforward matches—coders weren't struggling with medical complexity, they were losing time on obvious cases and context-switching between systems.

COMPETITIVE ANALYSIS
Evaluated existing auto-coding solutions. Common gaps: poor EDC integration, opaque matching logic, and insufficient audit capabilities for regulated environments.

REGULATORY REQUIREMENTS
Collaborated with regulatory affairs to define 21 CFR Part 11 compliance needs and establish validation requirements for algorithmic coding assistance.`,

    solution: `Defined a product strategy centered on "assistive intelligence"—augmenting coder expertise rather than replacing clinical judgment.

CORE CAPABILITIES
• Intelligent matching with confidence scoring to triage coder attention
• Full MedDRA hierarchy visibility (SOC → PT → LLT)
• EDC integration eliminating duplicate data entry
• Complete audit trail for every coding decision

DESIGN PRINCIPLES
• Transparency: Always show why a match was suggested
• Control: Manual override always available
• Compliance-first: Audit trail as foundation, not afterthought

Phased delivery starting with core matching, then EDC integration and batch processing.`,

    results: `The solution addressed the core workflow problems:

• Eliminated context-switching between multiple systems
• Automated obvious matches, focusing coder time on complex cases
• Reduced query rates through improved consistency
• Provided inspection-ready audit documentation

Pilot studies completed database lock ahead of schedule, and the tool saw strong adoption with positive coder feedback on workflow improvements.`,

    learnings: `WHAT WORKED
• Deep user research created advocates—coders saw their feedback in the product
• Confidence scoring built trust by surfacing uncertainty rather than hiding it
• Phased rollout allowed algorithm refinement before broader deployment

WHAT I'D APPROACH DIFFERENTLY
• Earlier regulatory affairs involvement to avoid late-stage compliance rework
• Batch processing in MVP rather than phase 2—users wanted it immediately
• More investment in change management for senior coders skeptical of automation

KEY INSIGHT
In regulated industries, the audit trail isn't a feature—it's the foundation. And "auto" doesn't mean "automatic"—the most successful automation augments human judgment rather than bypassing it.`
  }
},

{
  id: 'epro-accessibility',
  title: "Driving Accessibility & Usability in a Legacy ePRO Mobile Application",
  timeline: "2023",
  role: "Product Manager, Axiom",
  summary: "Led UI/UX improvements and accessibility feature development for a legacy ePRO mobile application, positioning the product ahead of evolving FDA diversity requirements and enabling support for more inclusive clinical trial cohorts.",
  problem: "The mobile app wasn't meeting accessibility standards while FDA guidelines were pushing sponsors to recruit diverse trial participants. Questionnaire completion rates were slipping and ease-of-use scores declining.",
metrics: [
  "UX & Accessibility Advocacy",
  "Overcoming Legacy Framework Challenges",
  "Market Positioning via Regulatory Shifts",
  "High Adoption Rate"
] ,
  skills: [
    "Regulatory Strategy",
    "Stakeholder Management",
    "UX Advocacy",
    "Market Analysis",
    "Legacy System Navigation",
    "A/B Testing",
    "Accessibility Standards"
  ],
  fullContent: {
    challenge: `Advocating for UX and UI improvements to mobile applications within a legacy system facing organizational and resource constraints.
Legacy software hurdles:
* Highly regulated change control process—justifications needed to be data-driven, UX-informed, and demonstrate regulatory accountability
* Dated codebase: modern mobile frameworks layered on top of older C#/.NET architecture
* Any change triggered extensive regression testing across the entire codebase
* New product features required extra layers of advocacy to get prioritized
The mobile app had functioned "well enough" through a period of plateauing usage, but cracks were showing. Questionnaire completion rates were slipping, ease-of-use scores were down, and the app wasn't meeting current accessibility standards. Meanwhile, the market was shifting with new FDA guidelines pushing sponsors to recruit more diverse trial participants, including people with disabilities. Positioning our mobile products to get ahead of this market shift would enable us to service modern study cohorts, thus leading to stronger support for the clinical research  industry.   My role: I led updates to the UI and advocated for accessibility features that enabled a stronger position in a changing regulated market—leading to new study enablement and, subsequently, better clinical research utilising diverse cohorts with greater representation.`,

    research: `* Reviewed FDA guidance on diversity requirements in clinical trial populations
* Benchmarked competitor apps for accessibility features and market positioning
* Dug into internal analytics to find drop-off points and usability friction
* Sized the market opportunity: clients were actively looking for solutions that could support diverse cohort recruitment`,

    solution: `Accessibility Features
* Adjustable font size
* Brightness settings
* Night mode toggle
* Zoom settings
* Voice-to-text dictation on text input fields
Audit Log Improvements
For regulatory compliance, clinical software needs detailed records of every data change. We overhauled the audit trail to:
* Capture previous values when edit-checks are triggered
* Record original responses, correction prompts, and any modifications
* Save input after each deliberate action (not just on form submission)
* Log all patient actions that create, modify, or delete records
Security Updates
* Added support for native device authentication (PIN, fingerprint, Face ID)
* Login credentials can now be stored and accessed through iOS and Android security protocols`,

    results: `A/B testing on new studies showed real improvements: lower drop-off rates, higher completion rates, and fewer support tickets related to usability. The updates rolled out across all active studies.`,

    learnings: `Legacy systems create friction. Entrenched processes can cause significant hurdles in shipping software. Getting buy-in required framing accessibility as a market opportunity, not just a UX improvement.
Accessibility benefits everyone. Features built for users with disabilities made the app easier for all participants to use.`
  }
}
  // Add more case studies by copying the object above
];
